// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__38oq6","row":"Node_row__25ZLN","label":"Node_label__3P3LD","footer":"Node_footer__39V9D"};